import(/* webpackMode: "eager", webpackExports: ["SentryProvider"] */ "/app/apps/web/app/sentry/SentryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/modules/ui/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["TolgeeNextProvider"] */ "/app/apps/web/tolgee/client.tsx");
